import React from "react";
import { Organization, WithContext } from "schema-dts";

import { BASE_ORGANIZATION_SCHEMA, EQUIPMENTSHARE_IMAGE_URL, POSTAL_ADDRESS_SCHEMA } from "../constants";
import { JSONLDComponent } from "../JSONLDComponent";

export const OrganizationSchema: React.FC = () => {
  const organizationData: WithContext<Organization> = {
    ...BASE_ORGANIZATION_SCHEMA,
    description:
      "We help contractors build with control. Our equipment and digital solutions empower contractors and construction professionals and our technology was made by contractors, for contractors, with the muscle and features that builders need to get the job done.",
    telephone: "888-807-3687",
    image: EQUIPMENTSHARE_IMAGE_URL,
    address: POSTAL_ADDRESS_SCHEMA,
    sameAs: [],
  };

  // Return if the current page is not homepage
  if (window.location.pathname !== "/") {
    return null;
  }

  return <JSONLDComponent structuredData={organizationData} />;
};
